import React from "react";
import { Box, Container, Heading, Text, VStack, SimpleGrid } from "@chakra-ui/react";
import Header from "./Header";

const Help: React.FC = () => {
    const primaryColor = "#1d4e4e";
    const white = "#ffffff";

    return (
        <Box>
            <Header />
            <Box bg="gray.50" minH="100vh" pt="5rem" pb={8}>
                <Container maxW="1200px">
                    <VStack gap={8} align="stretch">
                        <Box
                            bg={primaryColor}
                            p={10}
                            borderRadius="lg"
                            textAlign="center"
                            color={white}
                        >
                            <Heading as="h1" size="2xl" mb={4}>
                                Grader App Help Guide
                            </Heading>
                            <Text fontSize="xl">
                                Your comprehensive guide to using the Grade-R application
                            </Text>
                        </Box>

                        <Box bg={white} p={8} borderRadius="lg" boxShadow="md">
                            <Heading
                                as="h2"
                                size="lg"
                                color={primaryColor}
                                borderBottom="2px solid"
                                borderColor={primaryColor}
                                pb={2}
                                mb={4}
                            >
                                Getting Started
                            </Heading>
                            <Text mb={4}>
                                Welcome to Grade-R, your comprehensive academic grading and
                                management solution. This guide will help you understand and make
                                the most of all the features available in the application.
                            </Text>
                            <Box bg="orange.50" p={4} borderRadius="md" mb={4}>
                                <Text fontWeight="bold">Note:</Text> Make sure you have created an
                                account and are logged in to access all features.
                            </Box>
                        </Box>

                        <Box bg={white} p={8} borderRadius="lg" boxShadow="md">
                            <Heading
                                as="h2"
                                size="lg"
                                color={primaryColor}
                                borderBottom="2px solid"
                                borderColor={primaryColor}
                                pb={2}
                                mb={4}
                            >
                                Main Features
                            </Heading>
                            <SimpleGrid columns={{ base: 1, md: 3 }} gap={6}>
                                <Box
                                    bg="gray.50"
                                    p={6}
                                    borderRadius="md"
                                    borderLeft="4px solid"
                                    borderColor={primaryColor}
                                >
                                    <Heading as="h3" size="md" color={primaryColor} mb={3}>
                                        Dashboard
                                    </Heading>
                                    <Box as="ul" listStyleType="disc" pl={4}>
                                        <Box as="li" mb={2}>
                                            View your academic overview
                                        </Box>
                                        <Box as="li" mb={2}>
                                            Quick access to all semesters
                                        </Box>
                                        <Box as="li" mb={2}>
                                            Track your progress
                                        </Box>
                                    </Box>
                                </Box>
                                <Box
                                    bg="gray.50"
                                    p={6}
                                    borderRadius="md"
                                    borderLeft="4px solid"
                                    borderColor={primaryColor}
                                >
                                    <Heading as="h3" size="md" color={primaryColor} mb={3}>
                                        Grading System
                                    </Heading>
                                    <Box as="ul" listStyleType="disc" pl={4}>
                                        <Box as="li" mb={2}>
                                            Calculate grades for individual courses
                                        </Box>
                                        <Box as="li" mb={2}>
                                            View semester and final grades
                                        </Box>
                                        <Box as="li" mb={2}>
                                            Track GPA/CWA and CGPA, FGPA and Final CWA
                                        </Box>
                                    </Box>
                                </Box>
                                <Box
                                    bg="gray.50"
                                    p={6}
                                    borderRadius="md"
                                    borderLeft="4px solid"
                                    borderColor={primaryColor}
                                >
                                    <Heading as="h3" size="md" color={primaryColor} mb={3}>
                                        Course Management
                                    </Heading>
                                    <Box as="ul" listStyleType="disc" pl={4}>
                                        <Box as="li" mb={2}>
                                            Add and manage courses
                                        </Box>
                                        <Box as="li" mb={2}>
                                            Track course progress
                                        </Box>
                                        <Box as="li" mb={2}>
                                            View course history
                                        </Box>
                                    </Box>
                                </Box>
                            </SimpleGrid>
                        </Box>

                        <Box bg={white} p={8} borderRadius="lg" boxShadow="md">
                            <Heading
                                as="h2"
                                size="lg"
                                color={primaryColor}
                                borderBottom="2px solid"
                                borderColor={primaryColor}
                                pb={2}
                                mb={4}
                            >
                                Detailed Features
                            </Heading>

                            <Box mb={6}>
                                <Heading as="h3" size="md" color={primaryColor} mb={3}>
                                    1. Grade Calculation
                                </Heading>
                                <Box as="ul" listStyleType="disc" pl={4}>
                                    <Box as="li" mb={2}>
                                        <Text as="span" fontWeight="bold">
                                            Course Grades:
                                        </Text>{" "}
                                        Calculate grades for individual courses based on examination
                                        results
                                    </Box>
                                    <Box as="li" mb={2}>
                                        <Text as="span" fontWeight="bold">
                                            Semester Grades:
                                        </Text>{" "}
                                        View and calculate your semester performance
                                    </Box>
                                    <Box as="li" mb={2}>
                                        <Text as="span" fontWeight="bold">
                                            Final Grades:
                                        </Text>{" "}
                                        Track your overall academic performance
                                    </Box>
                                </Box>
                            </Box>

                            {/* <Box mb={6}>
                                <Heading as="h3" size="md" color={primaryColor} mb={3}>
                                    2. Institution Management
                                </Heading>
                                <Box as="ul" listStyleType="disc" pl={4}>
                                    <Box as="li" mb={2}>
                                        <Text as="span" fontWeight="bold">
                                            Institution Selection:
                                        </Text>{" "}
                                        Choose your educational institution
                                    </Box>
                                    <Box as="li" mb={2}>
                                        <Text as="span" fontWeight="bold">
                                            Grading System:
                                        </Text>{" "}
                                        View institution-specific grading policies
                                    </Box>
                                    <Box as="li" mb={2}>
                                        <Text as="span" fontWeight="bold">
                                            Class Tracking:
                                        </Text>{" "}
                                        Monitor your academic standing within your institution
                                    </Box>
                                </Box>
                            </Box> */}

                            <Box mb={6}>
                                <Heading as="h3" size="md" color={primaryColor} mb={3}>
                                    2. Premium Features
                                </Heading>
                                <Box as="ul" listStyleType="disc" pl={4}>
                                    <Box as="li" mb={2}>
                                        <Text as="span" fontWeight="bold">
                                            Advanced Analytics:
                                        </Text>{" "}
                                        Get detailed insights into your academic performance
                                    </Box>
                                    <Box as="li" mb={2}>
                                        <Text as="span" fontWeight="bold">
                                            Grade Predictions:
                                        </Text>{" "}
                                        Predict future grades based on current performance
                                    </Box>
                                    <Box as="li" mb={2}>
                                        <Text as="span" fontWeight="bold">
                                            Custom Reports:
                                        </Text>{" "}
                                        Generate detailed academic reports
                                    </Box>
                                </Box>
                            </Box>
                        </Box>

                        <Box bg={white} p={8} borderRadius="lg" boxShadow="md">
                            <Heading
                                as="h2"
                                size="lg"
                                color={primaryColor}
                                borderBottom="2px solid"
                                borderColor={primaryColor}
                                pb={2}
                                mb={4}
                            >
                                Tips for Best Use
                            </Heading>
                            <Box as="ul" listStyleType="disc" pl={4}>
                                <Box as="li" mb={2}>
                                    Regularly update your grades to maintain accurate records
                                </Box>
                                <Box as="li" mb={2}>
                                    Use the Target Grade feature to plan your academic strategy
                                </Box>
                                <Box as="li" mb={2}>
                                    Check your institution's specific grading policies and
                                    requirements before using the application
                                </Box>
                            </Box>
                        </Box>

                        <Box bg={white} p={8} borderRadius="lg" boxShadow="md">
                            <Heading
                                as="h2"
                                size="lg"
                                color={primaryColor}
                                borderBottom="2px solid"
                                borderColor={primaryColor}
                                pb={2}
                                mb={4}
                            >
                                Support
                            </Heading>
                            <Text mb={4}>
                                If you need additional help or have questions not covered in this
                                guide, please contact our support team:
                            </Text>
                            <Box as="ul" listStyleType="disc" pl={4}>
                                <Box as="li" mb={2}>
                                    Email: shedeurapps@gmail.com
                                </Box>
                                <Box as="li" mb={2}>
                                    Phone: +233 (24) 021-4327
                                </Box>
                                <Box as="li" mb={2}>
                                    Hours: Monday - Friday, 9:00 AM - 5:00 PM GMT
                                </Box>
                            </Box>
                        </Box>

                        <Box bg={white} p={8} borderRadius="lg" boxShadow="md">
                            <Heading
                                as="h2"
                                size="lg"
                                color={primaryColor}
                                borderBottom="2px solid"
                                borderColor={primaryColor}
                                pb={2}
                                mb={4}
                            >
                                Privacy and Security
                            </Heading>
                            <Text mb={4}>
                                Your academic data is important to us. We maintain strict privacy
                                and security measures to protect your information:
                            </Text>
                            <Box as="ul" listStyleType="disc" pl={4}>
                                <Box as="li" mb={2}>
                                    All data is encrypted in transit and at rest
                                </Box>
                                <Box as="li" mb={2}>
                                    Regular security audits and updates
                                </Box>
                                <Box as="li" mb={2}>
                                    Strict access controls and authentication
                                </Box>
                                <Box as="li" mb={2}>
                                    Your grading records are not shared with third parties
                                </Box>
                            </Box>
                        </Box>
                    </VStack>
                </Container>
            </Box>
        </Box>
    );
};

export default Help;
